import React, { Component, useEffect, useState, useContext } from "react";
import { Button, Input } from "reactstrap";
import { AppContext } from "../../AppContext";
import { postData } from "./ResultAPI";
import * as S from "./ResultStyle";

const sendRequestToDb = (body, url, props) => {
  postData(url, body).then((res) => {
    if (res) {
      console.log("sent");
    } else {
      console.log("error");
    }
  });
};

const sendRequest = (body, url, updateSuccessMessage) => {
  postData(url, body).then((res) => {
    if (res) {
      console.log("saadetud");
      updateSuccessMessage("Tagasiside on saadetud. Aitäh!");
    } else {
      console.log(body);
      console.log(url);
    }
  });
};

const sendToDb = (leftEarResult, result, age, sex, listeningDevice, props) => {
  const body = {
    age: age,
    sex: sex,
    left_result: leftEarResult,
    result: result,
  };

  sendRequestToDb(body, "HearingTestBack/DbConnector.php", props);
};

const sendToCsv = (
  leftEarResult,
  result,
  isImageTest,
  age,
  sex,
  listeningDevice,
  props
) => {
  const body = {
    isImageTest: isImageTest ? "piltTest" : "triplettTest",
    age: age,
    sex: sex,
    listeningDevice: listeningDevice,
    left_result: leftEarResult,
    result: result,
  };

  sendRequestToDb(body, "HearingTestBack/CsvConnector.php", props);
};

const FeedBack = (props) => {
  const [feedBack, setFeedBack] = useState("");
  const updateErrorMessage = props.updateErrorMessage;

  const sendFeedback = () => {
    if (feedBack === "") {
      updateErrorMessage("Tagasisidevorm on tühi");
    } else
      sendRequest(
        { feedback: feedBack },
        "HearingTestBack/FeedbackMailer.php",
        props.updateSuccessMessage
      );
  };

  const onInputChange = (event) => {
    setFeedBack(event.target.value);
  };

  return (
    <div id={"feedbackDiv"}>
      <p>Kuulmistesti parendamiseks oleme huvitatud teie tagasisidest:</p>
      <Input
        id={"feedbackText"}
        type="textarea"
        value={feedBack}
        onChange={onInputChange}
      />
      <Button
        color="success"
        id={"sendFeedbackBtn"}
        size={"lg"}
        onClick={sendFeedback}
      >
        Saada tagasiside
      </Button>
    </div>
  );
};

const Results = (props) => {
  const { data } = useContext(AppContext);
  const leftEarResult = props.leftEarResult;
  const result = props.result;

  useEffect(() => {
    sendToCsv(
      leftEarResult,
      result,
      data.isImageTest,
      data.age,
      data.sex,
      data.listeningDevice,
      props
    );
  }, []);

  const CurrentResults = () => {
    if (props.leftEarResult === null)
      return (
        <div>
          <p>Teie kuulmisteravus on {getHearingLoss(props.result)}</p>
          <p>
            Te eristate sõnu, mis on müraga võrreldes tasemel {props.result}{" "}
            detsibelli.
          </p>
        </div>
      );
    else
      return (
        <div>
          <p>
            Teie kuulmisteravus vasakus kõrvas on{" "}
            {getHearingLoss(props.leftEarResult)}
          </p>
          <p>
            Teie kuulmisteravus paremas kõrvas on {getHearingLoss(props.result)}
          </p>
          <br />
          <p>
            Te eristate sõnu, mis on müraga võrreldes tasemel <br /> &emsp;
            vasak kõrv: {props.leftEarResult} detsibelli.
            <br /> &emsp; parem kõrv: {props.result} detsibelli.{" "}
          </p>
        </div>
      );
  };

  const getHearingLoss = (result) => {
    if (props.leftEarResult === null) result = result + 2;
    if (result >= -2)
      return "oluliselt langenud. Kuulmisteravuse täpsemaks kontrolliks pöörduge audioloogi või kõrvaarsti poole, kes vajadusel soovitab teile sobiva kuuldeaparaadi.";
    else if (result <= -10) return "normi piires.";
    else return "mõõdukalt langenud.";
  };

  return (
    <S.Container>
      <h3>Tulemused</h3>
      <CurrentResults />
      <FeedBack
        updateErrorMessage={props.updateErrorMessage}
        updateSuccessMessage={props.updateSuccessMessage}
      />
    </S.Container>
  );
};

export default Results;
